import { render, staticRenderFns } from "./sales_area.vue?vue&type=template&id=1b795347"
import script from "./sales_area.vue?vue&type=script&lang=js"
export * from "./sales_area.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins_home/workspace/tax-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b795347')) {
      api.createRecord('1b795347', component.options)
    } else {
      api.reload('1b795347', component.options)
    }
    module.hot.accept("./sales_area.vue?vue&type=template&id=1b795347", function () {
      api.rerender('1b795347', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/dms/views/contract/target/form/sales_area/sales_area.vue"
export default component.exports